import { gql } from "lib/apolloClient";

export const createTimetableSlotResourceMutation = gql`
  mutation createTimetableSlotResource(
    $input: CreateLearningCourseFlowResourceInput!
  ) {
    planner {
      createLearningCourseFlowResource(input: $input) {
        id
        item {
          id
        }
      }
    }
  }
`;

export const importTimetableSlotResourceMutation = gql`
  mutation importTimetableSlotResource(
    $input: ImportLearningCourseFlowResourceInput!
  ) {
    planner {
      importLearningCourseFlowResource(input: $input) {
        isSuccess
        error
      }
    }
  }
`;

export const updateTimetableSlotItemsMutation = gql`
  mutation updateTimetableSlotItems($input: UpdateTimetableSlotItemInput!) {
    platform {
      updateTimetableSlotItem(input: $input)
    }
  }
`;

export const updateTimetableSlotResourceMutation = gql`
  mutation updateTimetableSlotResource(
    $input: UpdateLearningCourseFlowResourceInput!
  ) {
    planner {
      updateLearningCourseFlowResource(input: $input) {
        id
      }
    }
  }
`;

export const duplicateTimetableSlotContentMutation = gql`
  mutation copyTimetableSlotContent($input: CopyTimetableContentInput!) {
    platform {
      copyTimetableSlotContent(input: $input)
      __typename
    }
  }
`;

export const moveTimetableSlotContentMutation = gql`
  mutation moveTimetableSlotContent($input: CopyTimetableContentInput!) {
    platform {
      moveTimetableSlotContent(input: $input)
    }
  }
`;

export const reorderTimetableSlotContentMutation = gql`
  mutation reorderTimetableSlotContent(
    $input: TimetableSlotContentReorderInput!
  ) {
    platform {
      reorderTimetableSlotContent(input: $input)
    }
  }
`;

export const clearTimetableSlotContentMutation = gql`
  mutation clearTimetableItemContent($input: ClearTimetableSlotContentInput!) {
    platform {
      clearTimetableItemContent(input: $input)
    }
  }
`;

export const getTimetablePlannerDownloadUrlMutation = gql`
  mutation getTimetablePlannerDownloadUrl(
    $input: TimetablePlannerDownloadUrlInput!
  ) {
    platform {
      timetablePlannerDownloadUrl(input: $input) {
        url
        isSuccess
        warning
        longRunningTaskCreated
      }
    }
  }
`;
